import React from 'react';
import { IBox, Content} from '../inspinia';
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'
import { event } from 'jquery';

export default class TagCarimbo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: null, 
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }
    }

    hrefEmpty(){
    }

    getTags() {
        if (!this.state.tags) {
            return;
        }
        return this.state.tags.map(function (tag){
            return (
                <a key={tag.nome_campo} name={tag.nome_campo} href={'TAGSELECTORHTML:' + tag.nome_campo} className="d-block text-grey tag-selector" onClick={this.props.onClick}><strong>{tag.nome_campo}</strong></a>
            );
        }.bind(this));
    }
 
    CarregarTags(){
        let self = this;

        const url = `${c.API_BASE_URL}/template-carimbo-tempo/tags/all`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({ ...self.state, tags: response });
        })
    }

    componentDidMount() {
        this.CarregarTags();
    }

    render() {
        const props = this.props;

        return (
            <IBox className="mb-0 text-left">
                <Content style={{ border: "solid 1px #dcdcdc", borderTop: "solid 4px #dcdcdc", maxHeight: "184px", overflowY: "auto" }}>
                    <span className="fs-14 fw-600 text-body">Tags:</span>

                    <div className="tags fs-12 fw-400" style={{ lineHeight: "26px", padding: "0px" }}>
                        {this.getTags()}
                    </div>
                </Content>
            </IBox>
        )
    }
}
